import { useState, useContext, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { LeaderboardContext } from "../../provider/leaderboard";
import { useMediaQuery } from "react-responsive";
import { useAccount } from "wagmi";

// Assets
import { ReactComponent as SearchIcon } from "../../assets/media/icons/SearchIcon.svg";
import axios from "axios";
import { SERVER_URL } from "../../constants/env";

// Components
import Loader from "../../components/Loader";
import Footer from "../../components/Footer/Footer";
import Termresult from "../../components/termresult";
import PLTrackerNoWallet from "./PLTrackerNoWallet";
import WinPopup from "../../components/WinPopup/WinPopup";
import { UserContext } from "../../provider/userprovider";
import HourCountdownTimer from "../../components/CountdownTimer/HourCountDownTimer";
import Notification from "../../components/Notification/Notification";
import Modal from "../../components/modal";
// Styles
import "./index.scss";
import CurrentRankPanel from "../../components/CurrentRankPanel";
const LeaderBoard = (props) => {
  const [searchParams] = useSearchParams();
  const showLeaderboardRingsBackground = searchParams.get("tab") === "leaderboard";
  const { address, isConnected } = useAccount();
  const user = useContext(UserContext);
  const { userRank } = user;
  const { setSignUpModalShow, signUpModalShow } = useContext(UserContext);
  const isTabletDevice = useMediaQuery({ query: "(max-width: 889px)" });
  const isSmallDevice = useMediaQuery({
    query: "(max-width: 480px)",
  });
  const searchBarRef = useRef(null);
  const searchBarRefMobile = useRef(null);

  const {
    handleSearch,
    handleInputPaste,
    setSearchInput,
    loadingTW,
    userlostamount,
    winnerCount,
  } = useContext(LeaderboardContext);
  const [currentUserRank, setCurrentUserRank] = useState({
    rank: userRank?.rank || 0,
    points: userRank?.points || 0,
  });
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  useEffect(() => {
    document.title = "Fortune Foes | NFT PNL League";
  }, []);

  useEffect(() => {
    setIsNotificationOpen(userlostamount.iswinner);
  }, [userlostamount]);

  useEffect(() => {
    const handleReset = (event) => {
      if (
        searchBarRef.current &&
        !searchBarRef.current.contains(event.target)
      ) {
        searchBarRef.current.value = "";
        searchBarRefMobile.current.value = "";
        setSearchInput("");
      }
    };

    document.addEventListener("mousedown", handleReset);

    return () => {
      document.removeEventListener("mousedown", handleReset);
    };
  }, []);

  useEffect(() => {
    getMyInfo();
  }, [isConnected]);
  const getMyInfo = async () => {
    const userId = localStorage.getItem("pnl_id");

    if (!userId) return false;

    let result = await axios
      .get(`${SERVER_URL}users/currentuser`, {
        headers: {
          Authorization: `${localStorage.getItem("pnl_token")}`,
        },
      })
      .then((result) => {
        setCurrentUserRank({
          rank: result?.data?.rank,
          points: result?.data?.points,
        });
      })
      .catch((error) => {
        console.log(error);
        return false;
      });

    return result;
  };

  // Removed chart navigation buttons - only showing one leaderboard type

  const showLegacyLeaderboard = false;

  return showLegacyLeaderboard ? (
    <>
      {isNotificationOpen && (
        <Notification
          setIsNotificationOpen={setIsNotificationOpen}
          totalRevenue={userlostamount.totalRevenue}
        />
      )}
      {loadingTW && <Loader />}
      {/* Mobile search */}
      <Modal
        visible={signUpModalShow}
        close={() => setSignUpModalShow(false)}
        title="SIGN UP"
      >
        <div className="signup-walletadress">
          <div className="warning-text">
            <p>
              *In order to participate verify your wallet address and social
              handle.
            </p>
          </div>
          <div className="modal-wallet-wrapper">
            <p>
              <span style={{ color: "red" }}>
                * Please complete your authentication in the Allowlist Page.
              </span>
            </p>
          </div>
          <div className="signup-buttons-wrapper">
            <div
              className="login-twitter"
              onClick={() =>
                (window.location.href =
                  "https://fortunefoes.pages.dev/allowlist")
              }
            >
              <span style={{ cursor: "pointer" }}>Return</span>
            </div>
          </div>
        </div>
      </Modal>
      <div className="search-mobile">
        <SearchIcon className="search-icon" />
        <input
          ref={searchBarRefMobile}
          type="text"
          className="leaderboard-search"
          placeholder="SEARCH USERs"
          onChange={(e) => handleSearch(e)}
          onPaste={(e) => handleInputPaste(e)}
        />
      </div>
      {/* Mobile search */}
      <div className="leaderboard">
        <div className="leaderboard-page-top">
          <div className="left-side">
            <div className="leaderboard-chart-wrapper">
              <div className="leaderboard-chart-top-buttons">
                <div className="leaderboard-chart-top-left">
                  <div className="leaderboard-title">LEADERBOARD</div>
                </div>

                <div className="leaderboard-chart-top-right">
                  <SearchIcon className="search-icon" />
                  <input
                    ref={searchBarRef}
                    type="text"
                    className="leaderboard-search"
                    placeholder="SEARCH USER"
                    onChange={(e) => handleSearch(e)}
                    onPaste={(e) => handleInputPaste(e)}
                  />
                </div>
              </div>
              <div className="leaderboard-top-table-headers">
                <div className="leaderboard-top-table-header-left">
                  <div className="leaderboard-top-table-header-rank">RANK</div>
                  <div className="leaderboard-top-table-header-wallet-address">
                    USER
                  </div>
                </div>

                <div className="leaderboard-top-table-header-left">
                  <div className="leaderboard-top-table-header-lost-gained-amount">
                    Prize Points
                  </div>
                  <div className="leaderboard-top-table-header-lost-gained-amount">
                    NFT Trade Volume
                  </div>
                  <div className="leaderboard-top-table-header-lost-gained-amount">
                    NFT PNL
                  </div>
                </div>
              </div>
              <div className="leaderboard-list">
                <Termresult />
              </div>
            </div>
          </div>

          <div className="right-side">
            {/* <div className="region-filters-box">
              <div className="logintojoin-leaderboard">
                <HourCountdownTimer />
              </div>
            </div> */}
            <CurrentRankPanel userRank={currentUserRank} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  ) : (
    <div
      className={`leaderboard-nowallet-layout${
        showLeaderboardRingsBackground ? " leaderboard-nowallet-layout--rings" : ""
      }`}
    >
      <PLTrackerNoWallet />
    </div>
  );
};

export default LeaderBoard;
